/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Vendor_Return_Waiting_On_ShipmentInputs */

const en_vendor_return_waiting_on_shipment = /** @type {(inputs: Vendor_Return_Waiting_On_ShipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on the warehouse · shipment · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on the warehouse · shipment · since {since}" |
*
* @param {Vendor_Return_Waiting_On_ShipmentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const vendor_return_waiting_on_shipment = /** @type {((inputs: Vendor_Return_Waiting_On_ShipmentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vendor_Return_Waiting_On_ShipmentInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_vendor_return_waiting_on_shipment(inputs)
});